import { useSelector } from "react-redux";
import { Spinner } from "react-bootstrap";

import { loadingGlobalSelector } from "../../reducers";

export default function LoadingGlobal() {
  const showLoadingGlobal = useSelector(loadingGlobalSelector);

  return showLoadingGlobal === true &&
  <div className="loading-global">
    <Spinner animation="border" role="status" variant="primary" />
  </div>;
}
